import { network } from 'services/network';
import { useQuery } from 'react-query';
import { QueryKeys } from 'api/queryKeys';
import qs from 'qs';

const queryFn = () => {
    const queryString = qs.stringify({ name: location.hostname }, { addQueryPrefix: true, skipNulls: true });
    const url = `admin/bo/getServerTime${queryString}`;

    return network.post(url).then((response) => {
        return response.data;
    });
};
export const useQueryServerTime = () => {
    return useQuery<QueryResponse, QueryError, QueryResponse, QueryKeys>({
        queryKey: 'getServerTime',
        queryFn: () => queryFn(),
        cacheTime: 0,
        placeholderData: {
            time: new Date().valueOf(),
        },
    });
};

interface QueryResponse {
    time: number;
}
